import AllMessages from '@/graphql/chat/queries/all-messages.query'
import OnMessage from '@/graphql/chat/subscriptions/on-message.subscription'
import CreateMessage from '@/graphql/chat/mutations/create-message.mutation'
import UpdateConversation from '@/graphql/chat/mutations/update-conversation.mutation'
import UpdateMessage from '@/graphql/chat/mutations/update-message.mutation'
import OnMessageUpdateReaded from '@/graphql/chat/subscriptions/on-message-update-readed.subscription'
import SendMail from '@/graphql/chat/queries/send-mail.query'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import axios from 'axios'
const slackUrl = 'https://hooks.slack.com/services/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'

export default {
  name: 'chatDetail',
  props: [ 'id', 'room' ],
  components: {
    Datepicker
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    avatar () {
      return this.$store.getters.avatar
    },
    env () {
      return this.$store.getters.env
    },
    api () {
      return this.$store.getters.api
    },
    sortedItems () {
      return this.allMessages.items.sort((a, b) => {
        return (new Date(a.createdAt) < new Date(b.createdAt)) ? -1 : (new Date(a.createdAt) > new Date(b.createdAt)) ? 1 : 0
      })
    }
  },
  data () {
    return {
      allMessages: {
        items: []
      },
      content: '',
      pagination: {},
      loading: false,
      scout: {
        fee: 0,
        startDate: '',
        workableTime: {
          mon: {},
          tue: {},
          wed: {},
          tus: {},
          fri: {},
          sat: {},
          sun: {}
        }
      },
      contact: {},
      student: {},
      isInfo: true,
      fields: [
        { key: 'time', label: '', class: 'text-primary font-weight-bold' },
        { key: 'mon', label: '月' },
        { key: 'tue', label: '火' },
        { key: 'wed', label: '水' },
        { key: 'tus', label: '木' },
        { key: 'fri', label: '金' },
        { key: 'sat', label: '土' },
        { key: 'sun', label: '日' }
      ],
      items: [
        { time: { label: '9:00 〜 12:00', value: 1 } },
        { time: { label: '12:00 〜 15:00', value: 2 } },
        { time: { label: '15:00 〜 18:00', value: 3 } },
        { time: { label: '18:00 〜 21:00', value: 4 } }
      ],
      updating: {
        accept: false,
        cancel: false,
        recruit: false,
        notAdopted: false
      },
      scoutWidth: 0,
      placeholder: 'メッセージを入力してください',
      isRecruit: false,
      isFalse: false,
      reason: '',
      ja: ja,
      firstDate: '',
      error: {}
    }
  },
  methods: {
    async getMessage (after, count) {
      const roomsResponse = await this.$apollo.query({
        query: AllMessages,
        fetchPolicy: 'network-only',
        variables: {
          conversationId: this.id,
          first: count,
          after: after
        }
      })

      return {
        items: roomsResponse.data.allMessages.items,
        nextToken: roomsResponse.data.allMessages.nextToken
      }
    },
    async getMessages () {
      this.pagination.loading = true

      const { items, nextToken } = await this.getMessage(this.pagination.nextToken)

      this.allMessages.items = items
      this.pagination.nextToken = nextToken
      this.pagination.loading = false

      await this.readMessages()
      this.$emit('read')
    },
    getAvatar (type, avatarId) {
      return `${this.env.S3}/${type}/avatar/${avatarId}.png`
    },
    async sendMessage () {
      if (this.content) {
        const content = this.content
        this.content = ''

        const messageResponce = await this.$apollo.mutate({
          mutation: CreateMessage,
          variables: {
            input: {
              ownerId: this.user.enterpriseId,
              opponentId: this.room.opponentId,
              conversationId: this.room.id,
              ownerType: 'ENTERPRISE',
              opponentType: 'STUDENT',
              content,
              createdAt: new Date()
            }
          }
        })

        await this.$apollo.mutate({
          mutation: UpdateConversation,
          variables: {
            input: {
              id: this.room.id,
              userId: this.room.opponentId,
              lastMessageId: messageResponce.data.createMessage.id,
              updatedAt: new Date()
            }
          }
        })

        await this.$apollo.mutate({
          mutation: UpdateConversation,
          variables: {
            input: {
              id: this.room.id,
              userId: this.user.enterpriseId,
              lastMessageId: messageResponce.data.createMessage.id,
              updatedAt: new Date()
            }
          }
        })

        setTimeout(() => {
          document.getElementById(this.sortedItems[this.sortedItems.length - 1].id).scrollIntoView()
        })

        this.sendMail(this.room.opponent.email,
          this.room.opponent.name,
          this.room.user.name,
          content,
          `${this.env.STU_DOMAIN}/chat?id=${this.room.id}`)

        this.sendSlackHook(this.room, messageResponce.data.createMessage)
      }
    },
    async sendMail (to, receiver, actor, message, url) {
      try {
        await this.$apollo.query({
          query: SendMail,
          fetchPolicy: 'network-only',
          variables: {
            to,
            receiver,
            actor,
            message,
            url,
            student: true,
            company: false,
            fromSwipe: this.contact.type === 1
          }
        })
      } catch (e) {
        console.error(e)
      }
    },
    sendSlackHook (room, message) {
      let title = `[${this.env.STAGE}][企業]メッセージを送信しました`
      let color = '#28a745'

      const body = {
        attachments: [
          {
            fallback: title,
            color: color,
            fields: [
              {
                title: title,
                value: `ルームid: ${room.id}\n` +
                       `メッセージid: ${message.id}\n` +
                       `送信者: ${room.user.name}\n` +
                       `送信者id: ${room.user.id}\n` +
                       `受信者: ${room.opponent.name}\n` +
                       `受信者id: ${room.opponent.id}\n` +
                       `タイトル: ${room.title}\n` +
                       `内容: ${message.content}`
              }
            ]
          }
        ]
      }

      axios.post(slackUrl, JSON.stringify(body), { responseType: 'text' })
    },
    async readMessages () {
      for (let i in this.allMessages.items) {
        if (this.allMessages.items[i].ownerType !== 'ENTERPRISE' && !this.allMessages.items[i].readedAt) {
          await this.$apollo.mutate({
            mutation: UpdateMessage,
            variables: {
              input: {
                id: this.allMessages.items[i].id
              }
            }
          })

          this.allMessages.items[i].readedAt = new Date()
        }
      }
    },
    diffDate (i) {
      let dt = new Date(this.sortedItems[i].createdAt)

      if (!i) return `${dt.getFullYear()}/${dt.getMonth() + 1}/${dt.getDate()}`

      let preDt = new Date(this.sortedItems[i - 1].createdAt)

      if (!(dt.getFullYear() === preDt.getFullYear() &&
           dt.getMonth() === preDt.getMonth() &&
           dt.getDate() === preDt.getDate())
      ) {
        return `${dt.getFullYear()}/${dt.getMonth() + 1}/${dt.getDate()}`
      }
    },
    getDate (utcString) {
      let dt = new Date(utcString)
      return `${dt.getHours()}:${dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes()}`
    },
    watchScroll () {
      let chat = document.getElementById('chat')
      let lastElement = chat.appendChild(document.createElement('div'))

      chat.onscroll = () => {
        let scrollingPosition = chat.scrollTop + chat.clientHeight
        let bottomPosition = lastElement.offsetTop - chat.offsetTop

        if (scrollingPosition >= bottomPosition) {
          for (const message of this.allMessages.items) {
            if (message.ownerType !== 'ENTERPRISE' && !message.readedAt) {
              this.readMessages()
              this.$emit('read')
            }
          }
        }
      }
    },
    getIntern () {
      this.contact = {}
      let pathParams = {
        internId: this.room.internId
      }

      let additionalParams = {
        queryParams: {
          type: 'scout'
        }
      }

      this.$apig.get(this.api.INTERN, pathParams, additionalParams, {})
        .then(response => {
          this.scout = response.data
          if (response.data.status === 0) {
            this.placeholder = 'スカウトを承認するとメッセージが可能になります'
          }

          // this.isInfo = true
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    getContact () {
      this.scout = {
        fee: 0,
        startDate: '',
        workableTime: {
          mon: {},
          tue: {},
          wed: {},
          tus: {},
          fri: {},
          sat: {},
          sun: {}
        }
      }

      let pathParams = {
        conversationId: this.room.id
      }

      let additionalParams = {
        queryParams: {
          type: 'detail'
        }
      }

      this.$apig.get(this.api.CONTACT, pathParams, additionalParams, {})
        .then(response => {
          this.contact = response.data.contact
          this.student = response.data.student

          // this.isInfo = true
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    update (key) {
      this.updating[key] = true
      let firstDate
      if (key === 'recruit') firstDate = `${this.firstDate.getFullYear()}-${this.firstDate.getMonth() + 1}-${this.firstDate.getDate()}`

      let pathParams = {}

      if (this.room.internId) pathParams.internId = this.room.internId
      else pathParams.conversationId = this.room.id

      let additionalParams = {
        queryParams: {
          type: key
        }
      }

      let body = {
        firstDate,
        reason: this.reason || undefined
      }

      this.$apig.patch(this.room.internId ? this.api.INTERN : this.api.CONTACT, pathParams, additionalParams, body)
        .then(response => {
          switch (key) {
            case 'accept':
              this.scout.status = 1
              this.placeholder = 'メッセージを入力してください'
              this.content = `${this.room.user.name}さんがスカウトを承認しました。\n` +
                `メッセージで面談日程を決めましょう。`
              break
            case 'cancel':
              this.scout.status = 2
              this.content = `${this.room.user.name}さんがスカウトを辞退しました。`
              break
            case 'recruit':
              if (this.room.interdId) this.scout.status = 3
              else this.contact.status = 3
              this.content = `${this.room.opponent.name}さんの採用が決定しました。おめでとうございます。\n` +
                `初回出勤日は${firstDate.replace(/-/g, '/')}です！`
              break
            case 'notAdopted':
              this.scout.status = 4
              this.content = `${this.room.user.name}さんが不採用を申告しました。\n\n` +
                `【理由】\n${this.reason}`
              break
          }

          this.sendMessage()

          this.isRecruit = false
          this.isFalse = false
          this.updating[key] = false
        })
    }
  },
  async mounted () {
    this.loading = true
    await this.getMessages()
    if (this.room.opponent.name !== '退会したユーザー') {
      if (this.room.internId) this.getIntern()
      else this.getContact()
    }
    this.watchScroll()

    this.$nextTick(function () {
      document.getElementById(this.sortedItems[this.sortedItems.length - 1].id).scrollIntoView()
    })
  },
  watch: {
    sortedItems (newData, oldData) {
      this.loading = true
      if (this.room.opponent.name !== '退会したユーザー') {
        if (this.room.internId) this.getIntern()
        else this.getContact()
      }

      this.$nextTick(function () {
        this.watchScroll()
        document.getElementById(newData[newData.length - 1].id).scrollIntoView()
      })
    }
  },
  apollo: {
    allMessages: {
      query: () => AllMessages,
      fetchPolicy: 'network-only',
      variables () {
        return {
          conversationId: this.id
        }
      },
      subscribeToMore: [
        {
          document: OnMessage,
          variables () {
            return {
              conversationId: this.id
            }
          },
          updateQuery: async (previousResult, { subscriptionData: { data } }) => {
            return previousResult.allMessages.items.push(data.onMessage)
          }
        },
        {
          document: OnMessageUpdateReaded,
          variables () {
            return {
              conversationId: this.id,
              ownerId: this.user.enterpriseId
            }
          },
          updateQuery: async (previousResult, { subscriptionData: { data } }) => {
            for (let i in previousResult.allMessages.items) {
              if (previousResult.allMessages.items[i].id === data.onMessageUpdateReaded.id) {
                previousResult.allMessages.items[i].readedAt = data.onMessageUpdateReaded.readedAt
                return previousResult
              }
            }
          }
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/chat/detail/detail.js